import { forgotPassword, ValidationError } from './api';
import { FlyoutManager } from './flyoutManager';

export function initForgotPassword() {
    // try to find flyout
    const flyout = document.querySelector('[data-flyout="forgotPasswordForm"]');
    if (!flyout) return;
    
    // find elements
    const form = flyout.querySelector('form');
    const description = flyout.querySelector('.forgot-password-flyout__description');
    const emailInput = flyout.querySelector('input[type="email"]');
    const errorContainer = flyout.querySelector('[data-error-for="forgot-email"]');
    const successMessage = flyout.querySelector('.forgot-password-flyout__success');
    
    // save original display state
    const originalFormDisplay = form.style.display;
    const originalDescriptionDisplay = description.style.display;
    
    // reset form on close, but keep the email address
    FlyoutManager.subscribeToClosedEvent((e) => {
        if (e.detail.id === 'forgotPasswordForm') {
            form.style.display = originalFormDisplay;
            description.style.display = originalDescriptionDisplay;
            errorContainer.innerHTML = '';
            successMessage.classList.add('forgot-password-flyout__success--hidden');
        }
    });
    
    // hook submit
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        // submit to api, display any errors
        try {
            await forgotPassword(emailInput.value);
            successMessage.classList.remove('forgot-password-flyout__success--hidden');
            description.style.display = 'none';
            form.style.display = 'none';
            errorContainer.style.display = 'none';
        } catch (e) {
            errorContainer.style.display = 'block';
            
            if (e instanceof ValidationError) {
                const ul = document.createElement('ul');
                e.errors.forEach(error => {
                    const li = document.createElement('li');
                    li.textContent = error;
                    ul.appendChild(li);
                });
                
                errorContainer.replaceChildren(ul);
            } else {
                console.error(e);
                const div = document.createElement('div');
                div.textContent = 'Sorry, there was a problem sending the password reset email.';
                errorContainer.replaceChildren(div);
            }
        }
    });
}